class OurPhilosophy {
	constructor() {
		this._init();
	}

	_init() {
        $(document).ready(function(){
            $(".img-gallery").slice(0, 8).css('display', 'flex');
            $(".load-gallery").on("click", function(e){
              e.preventDefault();
              $(".img-gallery:hidden").slice(0, 4).css('display', 'flex');
              if($(".img-gallery:hidden").length == 0) {
                $(".load-gallery").css('display', 'none');
              }
            });

          })
    }
}

export default OurPhilosophy 